import { useEffect, useState } from 'react';
import {
  PanelBody,
  Button,
  Modal,
  TextControl,
  TextareaControl,
  Spinner,
  RadioControl,
  __experimentalNumberControl as NumberControl,
  SelectControl,
  FormToggle,
} from '@wordpress/components';
import { fetchData, saveData } from './api';

const FormCustomizerTab = ({ openPopup }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  const [isSaving, setIsSaving] = useState(false);
  const [fields, setFields] = useState([]); // Store existing fields
  const [editingFieldId, setEditingFieldId] = useState(null); // For editing
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [fieldName, setFieldName] = useState('');
  const [orderNumber, setOrderNumber] = useState('');
  const [fieldType, setFieldType] = useState('text'); // Field type state
  const [fieldLabel, setFieldLabel] = useState(''); // Field label state
  const [fieldRequired, setFieldRequired] = useState(false); // Field required state
  const [fieldEnable, setFieldEnable] = useState(false); 
  const [fieldOptions, setFieldOptions] = useState(''); // For options like select, radio

  useEffect(() => {
    fetchFields(); // Fetch existing fields on mount
  }, []);

  const fetchFields = () => {
    fetchData(gmwqp_wp_ajax.getsettings, gmwqp_wp_ajax.nonce)
      .then((fetchedData) => {
        setFields(fetchedData.custom_fields);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error('Error fetching settings:', error);
      });
  };

  const openModal = (field = null) => {
    setIsOpen(true);
    if (field) {
    console.log(field.options);
      setFieldName(field.name);
      setFieldLabel(field.label); // Label is being used as title
      setOrderNumber(field.order);
      setFieldType(field.type);
      setFieldRequired(field.required);
      setFieldEnable(field.enable);
      setFieldOptions(field.options.join('\n')); // Assuming options are stored as an array
    } else {
      resetForm(); // Reset for new field
    }
  };

  const closeModal = () => {
    setIsOpen(false);
    resetForm(); // Reset the form on close
  };

  const resetForm = () => {
    setFieldName('');
    setFieldLabel('');
    setOrderNumber('');
    setFieldType('text');
    setFieldRequired('');
    setFieldEnable('');
    setFieldOptions('');
    setEditingFieldId(null);
    setError("");
  };
 console.log(fieldType);
  const saveField = () => {

    const data = {
      name: fieldName,
      label: fieldLabel,
      order: orderNumber,
      type: fieldType,
      required: fieldRequired,
      enable: fieldEnable,
      options: fieldOptions,
    };
    setIsSaving(true);
    saveData(gmwqp_wp_ajax.savecustomfield, gmwqp_wp_ajax.nonce, data)
      .then((responseData) => {
        setIsSaving(false);
        if (responseData.success) {
          fetchFields();
          openPopup('Settings saved!');
        } else {
          setError(responseData.message);
        }
      })
      .catch((error) => {
        setIsSaving(false);
        console.error('Error saving settings:', error);
        openPopup('Failed to save settings.');
      });
  };

  const deleteField = (fieldId) => {
    if (confirm('Are you sure you want to delete this field?')) {
      setIsDeleting(true);
      const data = {
        name: fieldId,
      };
      saveData(gmwqp_wp_ajax.deletecustomfield, gmwqp_wp_ajax.nonce, data)
        .then((responseData) => {
          setIsDeleting(false);
          if (responseData.success) {
            fetchFields();
            openPopup(responseData.message);
          } else {
            openPopup(responseData.message);
          }
        })
        .catch((error) => {
          setIsDeleting(false);
          console.error('Error deleting field:', error);
          openPopup('Failed to delete field.');
        });
    }
  };

  return (
    <PanelBody>
      <div>
        <Button isPrimary onClick={() => openModal()} className="mb-10">
          Add Field
        </Button>
      </div>
      {loading ? (
        <Spinner />
      ) : (
        <>
          <div className="cfcblist">
            <table className="wp-list-table widefat fixed striped table-view-list">
              <thead>
                <tr>
                  <th>Enable / Disable</th>
                  <th>Label</th>
                  <th>Required</th>
                  <th>Type</th>
                  <th>Order</th>
                  <th>Options</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
               {fields.length > 0 ? (
                  fields.map((field) => (
                    <tr key={field.name}>
                      <td>{field.enable === 'yes' ? 'Yes' : 'No'}</td>
                      <td>{field.label}</td>
                      <td>{field.required === 'yes' ? 'Yes' : 'No'}</td>
                      <td>{field.type}</td>
                      <td>{field.order}</td>
                      <td>
                          {Array.isArray(field.options) ? (
                            field.options.map((option, index) => (
                              <span key={index}>
                                {option}
                                <br />
                              </span>
                            ))
                          ) : (
                            field.options?.split('\n').map((option, index) => (
                              <span key={index}>
                                {option}
                                <br />
                              </span>
                            ))
                          )}
                        </td>

                      <td>
                        <Button isPrimary onClick={() => openModal(field)}>
                          Edit
                        </Button>
                         {!['name', 'email', 'subject', 'mobile', 'enquiry'].includes(field.name) && (   
                            <Button
                              isDestructive
                              onClick={() => deleteField(field.name)}
                              disabled={isDeleting}
                            >
                              {isDeleting ? <Spinner size="small" /> : 'Delete'}
                            </Button>
                         )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" style={{ textAlign: 'center' }}>
                      No fields available.
                    </td>
                  </tr>
                )}

              </tbody>
            </table>
          </div>
        </>
      )}
      {isOpen && (
        <Modal title="Custom Field Add/Edit" onRequestClose={closeModal}>
          <div>

            {!['name', 'email', 'subject', 'mobile', 'enquiry'].includes(fieldName) && (    
                <div className="mb-10">
                    <SelectControl
                      label="Field Type"
                      value={fieldType}
                      onChange={setFieldType}
                      options={[
                        { label: 'Text', value: 'text' },
                        { label: 'Textarea', value: 'textarea' },
                        { label: 'Select', value: 'select' },
                        { label: 'Radio', value: 'radio' },
                        { label: 'Checkbox', value: 'checkbox' },
                      ]}
                      disabled
                    />
                </div>
            )}
            <div class="mb-10">
              <a href="https://www.codesmade.com/store/pdf-catalog-woocommerce-pro/" target="_blank">Get Pro Version</a>
            </div>
            <TextControl
              label="Field Label"
              value={fieldLabel}
              onChange={(value) => setFieldLabel(value)}
              placeholder="Enter Field Label"
              disabled
            />
            <NumberControl
              label="Field Order Number"
              value={orderNumber}
              onChange={(value) => setOrderNumber(value)}
              placeholder="Enter Field Order Number"
              className="mb-10"
              disabled
            />

            {['select', 'radio', 'checkbox'].includes(fieldType) && (
            <div className="mb-10">
              <TextareaControl
                label="Field Options"
                value={fieldOptions}
                onChange={setFieldOptions}
                placeholder={`Option 1\nOption 2\nOption 3`}
                disabled
              />
               </div>
            )}

            {!['name', 'email'].includes(fieldName) && ( 
            <div className="mb-10">
                <RadioControl
                    label="Field Enabled"  
                    selected={fieldEnable}
                    options={ [
                        { label: 'Yes', value: 'yes' },
                        { label: 'No', value: 'no' },
                    ] }
                    onChange={(value) => setFieldEnable(value)}
                   disabled
                />
                 </div>
             )}
             {!['name', 'email'].includes(fieldName) && ( 
             <div>
                    <RadioControl
                        label="Field Required"  
                        selected={fieldRequired}
                        options={ [
                            { label: 'Yes', value: 'yes' },
                            { label: 'No', value: 'no' },
                        ] }
                        onChange={(value) => setFieldRequired(value)}
                       disabled
                    />
                     </div>
            )}
          </div>
           {error!='' && ( 
              <div className="mt-10 errormsg">
              {error}
              </div>
           )}
          <div  className="mt-10">
            <Button isPrimary onClick={saveField} disabled={isSaving} disabled>
              {isSaving ? 'Saving...' : 'Save Field'}
            </Button>
            <Button isSecondary onClick={closeModal}>
              Cancel
            </Button>
          </div>
        </Modal>
      )}
    </PanelBody>
  );
};

export default FormCustomizerTab;
